"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsNumber = exports.isNumber = void 0;
const isInteger_1 = __importDefault(require("lodash/isInteger"));
const isNil_1 = __importDefault(require("lodash/isNil"));
const isNumber_1 = __importDefault(require("lodash/isNumber"));
const isString_1 = __importDefault(require("lodash/isString"));
const Exists_1 = require("../common/Exists");
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
// eslint-disable-next-line sonarjs/cognitive-complexity
async function isNumber(value, args, constraints) {
    var _a;
    // Attempt to convert string to number first if allowed
    if (!!(constraints === null || constraints === void 0 ? void 0 : constraints.allowString) && (0, isString_1.default)(value)) {
        value = value.length > 0 ? Number(value) : NaN;
        if (isNaN(value)) {
            return { pass: false, message: `should be a number` };
        }
    }
    const validateExistsResults = await (0, Exists_1.exists)(value, args, {
        isOptional: constraints === null || constraints === void 0 ? void 0 : constraints.isOptional,
        if: constraints === null || constraints === void 0 ? void 0 : constraints.if,
        allowEmptyString: true,
    });
    if (validateExistsResults.pass === false || validateExistsResults.skipped) {
        return validateExistsResults;
    }
    if (!(0, isNumber_1.default)(value)) {
        return { pass: false, message: `should be a number` };
    }
    // Number("badNumberString") will be "NaN"
    // need to NaN check when using with @Type(() => Number)
    if (isNaN(value)) {
        return { pass: false, message: `should be a number` };
    }
    if (!!(constraints === null || constraints === void 0 ? void 0 : constraints.isInt) && !(0, isInteger_1.default)(value)) {
        return { pass: false, message: `should be an integer` };
    }
    if ((!(0, isNil_1.default)(constraints === null || constraints === void 0 ? void 0 : constraints.min) && value < constraints.min) ||
        (!(0, isNil_1.default)(constraints === null || constraints === void 0 ? void 0 : constraints.max) && value > constraints.max)) {
        let message = `should be between ${constraints.min} and ${constraints.max}`;
        message = (0, isNil_1.default)(constraints === null || constraints === void 0 ? void 0 : constraints.min) ? `should be less than or equals to ${constraints.max}` : message;
        message = (0, isNil_1.default)(constraints === null || constraints === void 0 ? void 0 : constraints.max) ? `should be more than or equals to ${constraints.min}` : message;
        return { pass: false, message };
    }
    if (constraints === null || constraints === void 0 ? void 0 : constraints.maxDecimalPlaces) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [whole, decimal] = value.toString().split(".");
        const decimalPlaces = (_a = decimal === null || decimal === void 0 ? void 0 : decimal.length) !== null && _a !== void 0 ? _a : 0;
        if (decimalPlaces > constraints.maxDecimalPlaces) {
            return {
                pass: false,
                message: `should be a number with a maximum of ${constraints.maxDecimalPlaces} decimal places`,
            };
        }
    }
    if (!!(constraints === null || constraints === void 0 ? void 0 : constraints.isIn) && !constraints.isIn.includes(value)) {
        return { pass: false, message: `should be one of the following values: ${constraints.isIn.join(",")}` };
    }
    return { pass: true };
}
exports.isNumber = isNumber;
/**
 * Validates that the value is a valid number
 * NOTE: Differs from the class-validator version by allowing additional constraints
 */
function IsNumber(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IsNumber",
        defaultMessage: "should be a valid number",
        options,
        constraints,
        validateFn: isNumber,
    });
}
exports.IsNumber = IsNumber;
//# sourceMappingURL=IsNumber.js.map